
import { Component, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import Themeable from 'vuetify/lib/mixins/themeable';
import ScoreGradeRepositoryInterface, { ScoreGradeInterface } from '../../../../services/QA/scoreGrade/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'scoreGradeRepository',
  ],
})
export default class AllScoreTypes extends Vue {
  private readonly scoreGradeRepository: ScoreGradeRepositoryInterface;

  private loading: boolean = true;
  private scoreGrades: ScoreGradeInterface[] = [];

  private search: string = '';
  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Label', value: 'label' },
    { text: 'Value', value: 'value' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    this.scoreGrades = await this.scoreGradeRepository.getAllScoreGrades();
    this.loading = false;
  }

  private async createScoreType(): Promise<void> {
    await this.$router.push({ name: 'score_grade_create' });
  }

  private async editScoreGrade(scoreGradeId: number): Promise<void> {
    await this.$router.push({ name: 'score_grade_update', params: { scoreGradeId: String(scoreGradeId) } });
  }
}
